module.exports = __webpack_public_path__ + "img/qa_dc.34618b12.svg";